export default __webpack_public_path__ + "static/media/icon--fb.e3c7e76b.svg";